import React from "react";
import { Pressable, StyleSheet } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { colors } from "../../constants/theme";

/** Map top bar — search (opens search sheet). */
export default function MapSearchButton({ onPress }) {
  return (
    <Pressable onPress={onPress} style={styles.button}>
      <Ionicons name="search" size={20} color={colors.disgoBrown} />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    backgroundColor: colors.cream,
    borderRadius: 999,
    width: 44,
    height: 44,
    flexShrink: 0,
    flexGrow: 0,
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 2,
    borderColor: colors.borderLight,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 4,
  },
});
